export function SET_SOIL_AREAS(state, soilAreas) {
  state.soilAreas = soilAreas;
}

export function SET_AREA_SELECTED(state, area) {
  state.areaSelected = area;
}

export function SEARCH_AREA(state, toSearch) {
  state.search = toSearch;
}

export function SET_POLYGON_SELECTED(state, area) {
  state.polygonSelected = area;
}

export function SET_ADD_AREA(state, value) {
  state.isAddSoilSample = value;
}

export function PUSH_SOIL_AREAS(state, soilArea) {
  state.soilAreas.push(soilArea);
}

export function REPLACE_NAME_SOIL_AREAS(state, value) {
  for (let index = 0; index < state.soilAreas.length; index++) {
    if (state.soilAreas[index]._id == state.areaSelected._id) {
      state.soilAreas[index].name = value;
      break;
    }
  }
}

export function REPLACE_SOIL_AREAS(state, soilArea) {
  for (let index = 0; index < state.soilAreas.length; index++) {
    if (state.soilAreas[index]._id == state.areaSelected._id) {
      state.soilAreas[index] = soilArea;
      break;
    }
  }
}

export function DELETE_SOIL_AREAS(state, soilArea) {
  let index = state.soilAreas.indexOf(soilArea);
  state.soilAreas.splice(index, 1);
}

export function REMOVE_SOIL_AREAS(state, value) {
  state.removeFromMapCurrentArea = value;
}

export function SET_REDRAW(state, value) {
  state.isRedraw = value;
}

export function SET_AREA_REDRAW(state, value) {
  state.areaRedraw = value;
}

export function CLEAR_AREA_STATE(state) {
  state.soilAreas = [];
  state.areaSelected = null;
  state.search = "";
  state.polygonSelected = {};
  state.isAddSoilSample = false;
  state.removeFromMapCurrentArea = false;
  state.isRedraw = false;
  state.areaRedraw = null;
}
